import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { usersMfaBackend } from './users-mfa.backend';
import { usersMfaReducer } from './users-mfa.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('usersMfa', usersMfaReducer),
    BackendModule.forFeature('usersMfa', usersMfaBackend),
  ],
})
export class DatastoreUsersMfaModule {}
